module.exports = __webpack_public_path__ + "static/media/for-founders-third.d605475d.jpg";